var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.widgetType === "card"
    ? _c("card-widget", {
        attrs: { articles: _vm.articles, config: _vm.config }
      })
    : _vm.widgetType === "text"
    ? _c("text-widget", {
        attrs: { articles: _vm.articles, config: _vm.config }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }